import { z } from 'zod';

// ─── Response schema ──────────────────────────────────────────────────────────

export const billingAddressSchema = z.object({
  id: z.number(),
  /** Numeric org (partner) ID, null for personal addresses. */
  partner: z.number().nullable().catch(null),
  /** Current user's access level for this address. Null = view-only (e.g. in embedded org list). */
  authorizedRole: z.enum(['read', 'write', 'full']).nullable().catch(null),
  name: z.string().nullable(),
  street: z.string(),
  city: z.string(),
  zipCode: z.string(),
  country: z.string(),
  VAT_ID: z.string().nullable(),
  CRN: z.string().nullable(),
  email: z.string().catch(''),
});
export type BillingAddress = z.infer<typeof billingAddressSchema>;

// ─── Owner for creating a new address ────────────────────────────────────────

/**
 * Pass `orgId` (the Organization's string ID) to create an org address.
 * Omit `orgId` (or omit the owner entirely) for a personal address.
 */
export type BillingAddressOwner = { orgId?: number };

// ─── Request fields (shared between create / update) ─────────────────────────

const billingAddressRequestFieldsSchema = z.object({
  name: z.string(),
  street: z.string(),
  city: z.string(),
  zipCode: z.string(),
  country: z.string(),
  VAT_ID: z.string().nullable(),
  CRN: z.string().nullable(),
  email: z.string(),
});

// ─── Create request ───────────────────────────────────────────────────────────

export const createBillingAddressRequestSchema = billingAddressRequestFieldsSchema.extend({
  partner: z.number().optional(),
});
export type CreateBillingAddressRequest = z.infer<typeof createBillingAddressRequestSchema>;

// ─── Update request ───────────────────────────────────────────────────────────

export const updateBillingAddressRequestSchema = billingAddressRequestFieldsSchema;
export type UpdateBillingAddressRequest = z.infer<typeof updateBillingAddressRequestSchema>;
